// ارتفاع سطر جدول را از روی محتوای خود سطر حساب می کند تا متن بلند بریده نشود.
//
// جدول rsuite ارتفاع ثابت می خواهد و خودش با محتوا بزرگ نمی شود، ولی rowHeight
// را به صورت تابع هم می پذیرد. اینجا تخمین می زنیم چند خط لازم است.
//
// ملاک، طولانی ترین ستون متنی همان سطر است - نه فقط عنوان - چون هر ستونی که
// از بقیه بلندتر باشد همان است که ارتفاع را تعیین می کند.

const LineHeight = 20;
const BasePadding = 26;
const MinHeight = 46;

//--> ستون هایی که در جدول های این برنامه متن آزاد دارند. بقیه ستون ها
//--> (تاریخ، عدد، برچسب وضعیت) همیشه کوتاه اند و روی ارتفاع اثر ندارند.
const TextFields = ['title', 'fullName', 'ownerTitle', 'assignToFullName',
    'projectTitle', 'categoryTitle', 'companyTitle', 'creatorName', 'comment',
    'rejectComment'];

//--> دلیل رد زیر عنوان می نشیند، پس یک خط به سطر اضافه می کند و در
//--> بیشینه گرفتن ستون ها حساب نمی شود
export const NoteLine = 22;

/**
 * @param {object} rowData سطر جدول
 * @param {number} charsPerLine حدود چند حرف در هر خط جا می شود؛ هر صفحه
 *        بسته به عرض ستون هایش می تواند مقدار خودش را بدهد
 */
export const RowHeightOf = (rowData, charsPerLine) => {
    if (!rowData) {
        return MinHeight;
    }
    const perLine = charsPerLine > 0 ? charsPerLine : 55;

    let lines = 1;
    TextFields.forEach(field => {
        const value = rowData[field];
        if (value && typeof value === 'string') {
            const needed = Math.ceil(value.length / perLine);
            if (needed > lines) {
                lines = needed;
            }
        }
    });

    const height = BasePadding + (lines * LineHeight);
    return height > MinHeight ? height : MinHeight;
};

//--> امضای ساده برای rowHeight جدول
export const RowHeight = (rowData) => RowHeightOf(rowData, 55);

export default RowHeight;
